var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.onScroll,
      expression: "onScroll"
    }],
    staticClass: "scroll-top",
    attrs: {
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "color": "primary",
      "transition": "slide-x-transition"
    },
    on: {
      "click": function click($event) {
        return _vm.$vuetify.goTo(_vm.target, _vm.options);
      }
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column align-center"
  }, [_c('i', {
    staticClass: "icon icon-top-arrow mb-4 mb-lg-10"
  }), _c('span', {
    staticClass: "font-weight-bold page-text color-white line-height-1 text-center"
  }, [_vm._v(" TOP ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }